import moment from "moment";
import { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

// Antd components
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Input,
  message,
  Modal,
  Row,
  Select,
  TimePicker,
} from "antd";
import NewExternalSourceModal from "./NewExternalSourceModal";

// Actions
import { checkPromotionsPOS, fetchPromotionsPOS } from "@/store/actions/pos";
import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";
import { createNewCustomer } from "../../store/actions";
import instance from "../../store/actions/instance";
import { getCustomShippingRate, getDHLQuote } from "../../store/actions/pos";
import { GetEnglishOrArabic } from "./";
import OrderPayment from "./OrderPayment";
import { Big } from "bigdecimal.js";
window.Big = Big;

const { RangePicker } = TimePicker;
const { Option } = Select;
class OrderSettingsModal extends Component {
  state = {
    ...this.props.orderSettings,
    newExternalSourceModalVisible: false,
    customPaymentModallVisible: false,
    splitPaymentModalVisible: false,
    autoReceive: this.props.settings.automatically_receive_pos_orders,
    date:
      this.props.orderSettings.date ||
      moment().add(this.props.settings.minimum_lead_time_pos, "minutes"),
    start:
      this.props.orderSettings.start ||
      moment().add(this.props.settings.minimum_lead_time_pos, "minutes"),
    end:
      this.props.orderSettings.end ||
      moment().add(this.props.settings.minimum_lead_time_pos, "minutes"),

    paymentType:
      this.props.orderSettings.paymentType ||
      this.props.settings.default_payment_method_pos ||
      "cash",

    ordersByDate: {},
    orderLimits: {},

    paymentComplete: this.props.editOrder
      ? this.props.orderSettings.paymentComplete
      : this.props.settings.default_payment_status_pos,

    payments: this.props.orderSettings?.payments || [], //incase there were multiple payments
    loading: false,

    //Order total calculated from backend used to fix payments amounts
    actualOrderTotal: null,

    hybridTerminals: [],
    hybridTerminalsLoading: false,
    posTerminalId: this.props.orderSettings?.posTerminalId || null,
  };
  createOrderObj(order) {
    const { t, config } = this.props;
    return {
      key: order.id,
      index: order.type == "Order" ? order.id : "-",
      status: order.status,
      type: order.is_delivery ? "Delivery" : "Pick up",
      placed: moment(order.placed, "YYYY-MM-DDTHH:mm:ss").format(
        "DD-MM-YYYY h:mm A",
      ),
      received: order.received
        ? moment(order.received, "YYYY-MM-DDTHH:mm:ss").format(
            "DD-MM-YYYY h:mm A",
          )
        : "-",
      customer: [`${order.first_name} ${order.last_name}`, order.phone],
      tracking: order.tracking_id,
      expectedDate: order.expected_delivery_date
        ? moment(order.expected_delivery_date, "YYYY-MM-DD").format(
            "DD-MM-YYYY",
          )
        : "-",
      expectedTime: `${
        order.expected_delivery_slot_start
          ? moment(order.expected_delivery_slot_start, "HH:mm:ss").format(
              "h:mm A",
            )
          : ""
      } - ${
        order.expected_delivery_slot_end
          ? moment(order.expected_delivery_slot_end, "HH:mm:ss").format(
              "h:mm A",
            )
          : ""
      }`,
      area: order.area
        ? config.language == "arabic"
          ? order.area.ar_name
            ? order.area.ar_name
            : "-"
          : order.area.name
            ? order.area.name
            : "-"
        : "-",
      paymentType:
        order.payment_method == "cash"
          ? "Cash"
          : order.payment_method == "pos"
            ? `POS`
            : order.payment_method == "benefit-transfer"
              ? t("Benefit Transfer")
              : order.payment_method == "wallet"
                ? t("Wallet")
                : order.payment_method == "loyalty points"
                  ? t("Loyalty Points")
                  : order.payment_method == "custom"
                    ? `Custom (${order.payment_ctype})`
                    : `Online (${
                        order.payment_method?.includes("link") &&
                        !order.payment_complete
                          ? this.capitalizeFirstLetter(
                              order.payment_method
                                .split(" link")[0]
                                .split("_")[0],
                            )
                          : order.payment_ctype === "1"
                            ? "Knet"
                            : ["0", "2", "5"].includes(order.payment_ctype)
                              ? "credit"
                              : order.payment_ctype
                      })`,
      paymentStatus: order.payment_complete == true ? "Complete" : "Incomplete",
      paymentReference: order.payment_reference ? order.payment_reference : "-",
      promise:
        order.type == "Promise" || order.status === "New POS" ? true : false,
      obj: order,
    };
  }

  openInvoiceModal = (selectedOrder, status, paid) => {
    const openChargeModal =
      selectedOrder.paymentType === "Cash" && paid === "Complete";
    this.props.setStateIndex({
      quickActionModal: !openChargeModal,
      chargeModalVisible: openChargeModal,
      selectedOrder: selectedOrder,
      orderStatusValueInModal: status,
      paymentStatusValueInModal: paid,
    });
  };
  placeOrder = async (editOrder) => {
    if (this.state.loading) return;
    this.setState({ loading: true });
    try {
      let res = await this.props.placeOrder({
        ...this.state,
        stagedTotal: this.props.orderTotalPrice,
        date: this.state.date.format("YYYY-MM-DD").toString(),
        start: this.state.start.format("HH:mm").toString(),
        end: this.state.end.format("HH:mm").toString(),
      });

      if (res?.data?.message) {
        message.error(
          res?.data?.message ||
            "Error while creating the order, please try again",
        );

        if (
          res?.data?.message === "The promotion you used is no longer valid"
        ) {
          await this.props.fetchPromotionsPOS(this.props.t);
          await this.props.checkPromotionsPOS();
        }
        this.setState({ loading: false });
      } else {
        this.props.onClose();
        if (
          this.state.paymentType === "hybrid_terminal" &&
          this.state.posTerminalId
        ) {
          const terminal = this.state.hybridTerminals.find(
            (item) =>
              String(item.id) === String(this.state.posTerminalId),
          );
          const paymentTarget = res.data.checkout || res.data.order;
          if (terminal && paymentTarget) {
            this.props.startHybridTerminalPayment(
              paymentTarget,
              terminal,
              Boolean(res.data.checkout),
            );
          } else {
            message.error(
              this.props.t("The selected terminal is no longer available"),
            );
            if (!editOrder && res.data.order) {
              this.openInvoiceModal(
                this.createOrderObj(res.data.order),
                res.data.order.status,
                "Incomplete",
              );
            }
          }
        } else if (!editOrder) {
          this.openInvoiceModal(
            this.createOrderObj(res.data.order),
            res.data.order.status,
            res.data.order.payment_complete ? "Complete" : "Incomplete",
          );
        } else {
          message.success("Edited Successfully");
        }
        // if (res.data.new_customer) {
        //   this.props.createNewCustomer(res.data.new_customer);
        // }
      }
    } catch (err) {
      if (err.response?.data?.message == "Price Changed") {
        this.setState({
          actualOrderTotal: err.response?.data?.data.order_total,
        });
      }
      message.error(
        err.response?.data?.message ||
          "Error while creating the order, please try again",
      );

      this.setState({ loading: false });

      instance.post("log_error/", {
        title: "Place Order POS",
        store: this.props.settings?.domain,
        err: err.toString(),
        msg:
          err.response?.data?.message ||
          "Error while creating the order, please try again",
      });
    }
  };

  fetchHybridTerminals = async () => {
    this.setState({ hybridTerminalsLoading: true });
    try {
      const res = await instance.get("/hybrid_pos_terminals/");
      const terminals = res.data.terminals || [];
      this.setState({
        hybridTerminals: terminals,
        posTerminalId:
          this.state.posTerminalId ||
          (terminals.length === 1 ? terminals[0].id : null),
      });
    } catch (err) {
      this.setState({ hybridTerminals: [] });
    }
    this.setState({ hybridTerminalsLoading: false });
  };

  getOrderLimits = async () => {
    try {
      this.setState({ loading: true });
      const res = await instance.post("get_order_limits_pos/", {
        branch: this.props.currenctBranch,
      });
      this.setState({
        ordersByDate: res.data.all_orders,
        orderLimits: res.data.order_limits,
      });
    } catch (err) {
      message.error("SomethingWentWrong");
    }
    this.setState({ loading: false });
  };

  componentDidMount() {
    const { settings } = this.props;
    if (settings.enable_hybrid) {
      this.fetchHybridTerminals();
    }
    if (settings.enable_cash_for_pos === false) {
      this.setState({ paymentType: "online" });
    } else if (settings.enable_online_payments_for_pos === false) {
      this.setState({ paymentType: "cash" });
    }
    if (this.props.deliveryCharge === "TBD") {
      if (settings.has_custom_shipping_rates) {
        this.props.getCustomShippingRate();
      } else {
        this.props.getDHLQuote();
      }
    }
    if (settings.enable_limits && settings.show_order_limits_warnings_pos) {
      this.getOrderLimits();
    }

    if (this.props.address?.orderType === "Delivery") {
      const branch = this.props.branches.find(
        (branch) => branch.id === this.props.currentBranch,
      );
      const area_id = this.props.address?.deliveryAddress?.address?.area_id;
      const area = branch?.areas.find((area) => area.area_id === area_id);
      const on_demand_delivery_minutes = branch?.on_demand_delivery_minutes;

      if (
        area?.override_on_demand_delivery_minutes &&
        area?.override_on_demand_delivery_minutes_value > 0
      ) {
        this.setState({
          end: moment(this.state.end).add(
            area?.override_on_demand_delivery_minutes_value,
            "minutes",
          ),
        });
      } else if (on_demand_delivery_minutes > 0) {
        this.setState({
          end: moment(this.state.end).add(
            on_demand_delivery_minutes,
            "minutes",
          ),
        });
      }
    }
  }

  orderLimitText = (limitPerDay) => {
    const { t } = this.props;
    if (limitPerDay === undefined) {
      return "";
    }
    if (limitPerDay === 0) {
      return (
        <p
          style={{
            fontWeight: "bold",
            color: "red",
          }}
        >
          {t("You have reached the order limit for the selected date")}
        </p>
      );
    } else if (limitPerDay > 0) {
      return (
        <p
          style={{
            fontWeight: "bold",
            color: "red",
          }}
        >
          {t("You have $ orders left before reaching your limit").replace(
            "$",
            limitPerDay,
          )}
        </p>
      );
    } else {
      return (
        <p style={{ color: "red", fontWeight: "bold" }}>
          {t(
            "You’ve exceeded the order limit by $ order(s). Please adjust accordingly",
          ).replace("$", Math.abs(limitPerDay))}
        </p>
      );
    }
  };

  render() {
    const {
      t,
      config,
      visible,
      externalSources,
      externalSourcesLoading,
      editOrder,
      settings,
      customer,
      orderTotalPrice,

      manuallyAppliedPromotion,
      address,
      orderSettings,
    } = this.props;

    const {
      paymentComplete,
      paymentType,
      date,
      start,
      end,
      loading,
      autoReceive,
      newExternalSourceModalVisible,

      source,
      specialRemarks,
      paymentCType,
      paymentReference,
      ordersByDate,
      orderLimits,
      payments,
      actualOrderTotal,
    } = this.state;
    // Order Limits
    const dateFormat = date.format("YYYY-MM-DD");
    const orderCountForSelectedDate = ordersByDate[dateFormat] || 0;
    let dayOfWeek = (date.day() + 6) % 7;
    const limitPerDay = orderLimits[dayOfWeek] ?? Infinity;

    const disableButton =
      (this.props.settings.make_source_mandatory &&
        this.state.source == null) ||
      (paymentType === "hybrid_terminal" && !this.state.posTerminalId);

    return (
      <Modal
        style={{ top: 20 }}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {t("Finalize Order")}
          </div>
        }
        visible={visible}
        onCancel={!loading && this.props.onClose}
        footer={[
          <Button
            block
            loading={loading}
            className="posActionButton"
            style={{
              backgroundColor: disableButton ? "#f5f5f5" : "#009900",
              borderColor: disableButton ? "#d9d9d9" : "#009900",
            }}
            key="submit"
            type="primary"
            disabled={disableButton}
            onClick={() => this.placeOrder(editOrder)}
          >
            {t("Place Order")}
          </Button>,
        ]}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
      >
        {newExternalSourceModalVisible && (
          <NewExternalSourceModal
            visible={newExternalSourceModalVisible}
            onClose={(newSource) => {
              this.setState({
                newExternalSourceModalVisible: false,
                source: newSource ? newSource : source,
              });
            }}
          />
        )}

        {(!settings.hide_expected_time_for_none_delivery ||
          address?.orderType == "Delivery") &&
          !settings.enable_table_qr && (
            <div className="my-3 text-center">
              <p style={{ fontSize: 15 }}>{t("Date and Time")}</p>
              <Row justify="center">
                <Col span={8}>
                  <p>{t("Date")}</p>
                </Col>
                <Col span={12}>
                  <DatePicker
                    allowClear={false}
                    inputReadOnly={true}
                    value={date}
                    onChange={(e) => this.setState({ date: e })}
                  />
                </Col>
              </Row>
              <Row className="mt-3" justify="center">
                <Col span={8}>
                  <p>{t("Time")}</p>
                </Col>
                <Col span={12}>
                  <RangePicker
                    order={false}
                    inputReadOnly={true}
                    allowClear={false}
                    format="h:mm a"
                    value={[start, end]}
                    use12Hours
                    onChange={(e) => this.setState({ start: e[0], end: e[1] })}
                  />
                </Col>
              </Row>
            </div>
          )}
        {settings.enable_limits &&
          settings.show_order_limits_warnings_pos &&
          limitPerDay <= orderCountForSelectedDate + 5 && (
            <div className="mt-3 mb-4 text-center ">
              {this.orderLimitText(limitPerDay - orderCountForSelectedDate)}
            </div>
          )}

        <OrderPayment
          payments={payments} //TODO: check if using this is enough
          orderPayments={orderSettings?.payments || []}
          actualOrderTotal={actualOrderTotal}
          closePlaceOrderModal={this.props.onClose}
          editOrder={editOrder}
          orderTotalPrice={orderTotalPrice}
          paymentComplete={paymentComplete}
          paymentCType={paymentCType}
          paymentType={paymentType}
          paymentReference={paymentReference}
          hybridTerminals={this.state.hybridTerminals}
          hybridTerminalsLoading={this.state.hybridTerminalsLoading}
          posTerminalId={this.state.posTerminalId}
          setOrderSettingsState={(newState) => this.setState(newState)}
        />

        <div className="mt-3 mb-4 text-center">
          <p style={{ fontSize: 15 }}>{t("Special Remarks")}</p>
          <Input
            value={specialRemarks}
            placeholder={t("Special Remarks")}
            onChange={(e) =>
              this.setState({ specialRemarks: e.target.value.trimStart() })
            }
          />
        </div>

        <div className="mt-3 mb-4 text-center">
          <p style={{ fontSize: 15 }}>
            {" "}
            {t("Source")}{" "}
            {this.props.settings.make_source_mandatory && (
              <span
                style={{
                  color: "#ff4d4f",
                  fontSize: 15,
                  fontWeight: 500,
                }}
              >
                {"*"}
              </span>
            )}
          </p>
          <Select
            allowClear
            clearIcon={
              <CloseCircleFilled
                onClick={(e) => {
                  this.setState({ source: null });
                }}
              />
            }
            showSearch
            loading={externalSourcesLoading}
            style={{ width: "100%", textAlign: "left" }}
            optionFilterProp="children"
            placeholder={
              this.props.settings.make_source_mandatory
                ? t("Select a source")
                : t("Select a source (optional)")
            }
            filterOption={(input, option) => {
              if (typeof option.children == "object") return false;

              return (
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            value={source || undefined}
            onChange={(e) => {
              if (e === "new source") {
                this.setState({ newExternalSourceModalVisible: true });
              } else {
                this.setState({ source: e });
              }
            }}
          >
            {!externalSourcesLoading &&
              this.props.permissions.can_create_sources && (
                <Option key={"new source"} value={"new source"}>
                  <span style={{ whiteSpace: "break-spaces" }}>
                    {t("New Source")} <PlusOutlined className="mx-1" />
                  </span>
                </Option>
              )}
            {externalSources?.map((s) => (
              <Option key={s.id} value={s.id}>
                {GetEnglishOrArabic(s.name, s.ar_name, config.language)}
              </Option>
            ))}
          </Select>
        </div>
        <div className="mt-3 mb-4 text-center ">
          <p>
            <Checkbox
              className="mx-3"
              checked={autoReceive}
              onChange={(e) => {
                this.setState({ autoReceive: e.target.checked });
              }}
            />
            {`${t("Automatically Receive Order")}`}
          </p>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    permissions: state.auth.permissions,
    externalSources: state.pos.externalSources,
    externalSourcesLoading: state.pos.externalSourcesLoading,
    is_staff: state.auth.is_staff,
    settings: state.auth.settings,
    paymentMethods: state.pos.paymentMethods,
    customer: state.pos.customer,
    branches: state.locations.branches,
    manuallyAppliedPromotion: state.pos.manuallyAppliedPromotion,
    currenctBranch: state.pos.currentBranch,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    createNewCustomer: (customer) => dispatch(createNewCustomer(customer)),
    getDHLQuote: () => dispatch(getDHLQuote()),
    getCustomShippingRate: () => dispatch(getCustomShippingRate()),

    fetchPromotionsPOS: (t) => dispatch(fetchPromotionsPOS(t)),
    checkPromotionsPOS: (params) => dispatch(checkPromotionsPOS(params)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(OrderSettingsModal));
